import axios, { AxiosError } from 'axios'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import { BirthdayCancellationSummary } from '@facades/birthday'
import { getEndpoint } from '@utils/getEndpoint'

const cancellationEndpoint = (token: string) =>
  `${getEndpoint()}/birthday/orders/cancellation/${encodeURIComponent(token)}`

export const useBirthdayCancellation = (token: string) =>
  useQuery<BirthdayCancellationSummary, AxiosError>(
    ['birthday', 'cancellation', token],
    async () => {
      const response = await axios.get<BirthdayCancellationSummary>(
        cancellationEndpoint(token)
      )
      return response.data
    },
    { enabled: Boolean(token) }
  )

export const useCancelBirthdayOrder = (token: string) => {
  const queryClient = useQueryClient()
  return useMutation<
    {
      status: 'cancelled' | 'already_cancelled'
      confirmationEmailSent: boolean
      warning: 'cancellation_email_failed' | null
    },
    AxiosError,
    { reason: string }
  >(
    async ({ reason }) => {
      const response = await axios.post(cancellationEndpoint(token), { reason })
      return response.data
    },
    {
      onSuccess: async (result) => {
        const queryKey = ['birthday', 'cancellation', token]
        const current =
          queryClient.getQueryData<BirthdayCancellationSummary>(queryKey)
        if (current) {
          queryClient.setQueryData<BirthdayCancellationSummary>(queryKey, {
            ...current,
            status: 'cancelled',
            cancellationEmailSent: result.confirmationEmailSent,
          })
        }
        await queryClient.invalidateQueries(['birthday', 'availability'])
      },
    }
  )
}
